'use client';

import { MinusCircle, PlusCircle } from '@/components/_rebrand/Icons';
import ease from '@/constants/ease';
import { useModalButtonActions } from '@/hooks/useModalButtonActions';
import { motion } from 'framer-motion';
import { FC, useState } from 'react';

export type ServiceOfferingsProps = {
  serviceOfferingFeatures: {
    title: React.ReactNode;
    description: string;
  }[];
}

const ServiceOfferings: FC<ServiceOfferingsProps> = ({
  serviceOfferingFeatures = []
}) => {
  const [activeFeatureIndex, setFeatureIndex] = useState(0);
  const { modalActionHandler } = useModalButtonActions();
  const [isOpen, setIsOpen] = useState(true);

  const toggleServiceOffereing = (item: number) => {
    if (activeFeatureIndex === item) {
      setIsOpen(prev => !prev);
    } else {
      setFeatureIndex(item);
      setIsOpen(true);
    }
  }

  return (
    <section className="flex py-[24px] md:py-[120px] px-[24px] bg-white justify-center">
      <div className="flex w-full flex-wrap md:flex-nowrap max-w-grid items-start justify-between">
        <div className="flex flex-wrap w-full md:max-w-[624px] md:mr-[2%]">
          <h2 className="text-blue-900 font-500 text-display3">Services to help you scale</h2>
          <p className="text-gray-700 text-p1 mt-[12px] mb-[48px]">Get set up for long-term success by partnering with our team of experts. Request a consultation to learn more about our service add-ons for Professional and Enterprise plans.</p>
          <button
            className="block button button-size-medium button-primary-blue-900"
            onClick={() => {
              modalActionHandler("demo");
            }}
          >
            Talk to Sales
          </button>
        </div>
        <div className="flex flex-wrap w-full md:max-w-[512px] md:ml-[2%] mt-[40px] md:mt-0">
          {serviceOfferingFeatures.map((item, index) => (
            <div key={`ai-features-${index}`} className="flex border-b-[1px] border-solid border-violet-800 w-full items-start justify-between cursor-pointer" onClick={() => { toggleServiceOffereing(index); }}>
              <div className="flex text-p1 font-500 mt-[24px] mb-[24px]">
                <div className="flex flex-wrap">
                  {item.title}
                  {activeFeatureIndex === index && isOpen && (
                    <motion.div
                      className="text-p2 mt-[8px] font-400 text-blue-900 w-full mr-[8px]"
                      initial={{ opacity: 0, y: 5 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{
                        duration: 400 / 1000,
                        ease: ease.appear,
                      }}
                    >
                      {item.description}
                    </motion.div>
                  )}
                </div>
              </div>
              <div className="flex">
                {activeFeatureIndex === index && isOpen ? <motion.div
                  className="text-p2 mt-[24px] font-400 text-blue-900 w-full"
                  initial={{ opacity: 0, y: 5 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 400 / 1000,
                    ease: ease.appear,
                  }}
                >
                  {MinusCircle("#0D1D39")}
                </motion.div> : <motion.div
                  className="text-p2 mt-[24px] font-400 text-blue-900 w-full"
                  initial={{ opacity: 0, y: 5 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 400 / 1000,
                    ease: ease.appear,
                  }}
                >
                  {PlusCircle("#0D1D39")}
                </motion.div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOfferings;
